import { create } from 'zustand';

export interface VideoUrlModalStore {
  isOpen: boolean;
  callback: (url: string) => void;

  setIsOpen: (
    isOpen: VideoUrlModalStore['isOpen'],
    meta?: {
      callback: VideoUrlModalStore['callback'];
      initialUrl?: VideoUrlModalStore['initialUrl'];
      mode: VideoUrlModalStore['mode'];
    },
  ) => void;

  mode: null | 'add' | 'edit';
  reset: () => void;

  initialUrl: string;
}

export const useVideoUrlModalStore = create<VideoUrlModalStore>((set) => ({
  isOpen: false,
  mode: null,
  initialUrl: '',

  callback: () => {},

  setIsOpen: (isOpen, meta) => {
    set({
      isOpen,
      callback: meta?.callback,
      mode: meta?.mode,
      initialUrl: meta?.initialUrl,
    });
  },

  reset: () =>
    set({ isOpen: false, mode: null, initialUrl: '', callback: () => {} }),
}));
